import { render } from "./VLogo.vue?vue&type=template&id=0c3b97db"
import script from "./VLogo.vue?vue&type=script&lang=js"
export * from "./VLogo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__